import { render, staticRenderFns } from "./PrimaryMenuMobile.vue?vue&type=template&id=290ddbc3"
import script from "./PrimaryMenuMobile.vue?vue&type=script&lang=js"
export * from "./PrimaryMenuMobile.vue?vue&type=script&lang=js"
import style0 from "./PrimaryMenuMobile.vue?vue&type=style&index=0&id=290ddbc3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports